import { render, staticRenderFns } from "./UserDeleteClassForm.vue?vue&type=template&id=0f775c6c"
import script from "./UserDeleteClassForm.vue?vue&type=script&lang=js"
export * from "./UserDeleteClassForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports